import { GzNodeRenameInputWebComponent } from './component/GzNodeRenameInputWebComponent';
import { WEB_COMPONENT_GZ_NODE_RENAME_INPUT } from '../../../../webcomponents.constants';

export { GzNodeRenameInputWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_NODE_RENAME_INPUT, GzNodeRenameInputWebComponent);
